import React, { useContext, useState } from 'react';
import 'react-dropzone-uploader/dist/styles.css'
import Dropzone, {getFilesFromEvent} from "react-dropzone-uploader";
import {getApiSitePrefix} from "../functions/SiteDefaults";
import axios from "axios";
import SystemContext from "../SystemContext";
import readFileAsync from "../functions/ReadFileAsync";
import __ from "lodash";

const apiSitePrefix = getApiSitePrefix();

const DropzoneMultiFileUpload = (props) => {

  const SystemData = useContext(SystemContext);

  const objectType = props.objectType || "BOOKING";
  const awbNumber = props.awbNumber;
  const tripLegUuid = props.tripLegUuid;
  const documentUuid = props.documentUuid;
  const accept = props.accept;
  const dropzoneStyle = { border: "1px dashed", overflow: "auto", ...props.dropzoneStyle };
  const inputLabel = { ...props.inputLabel };
  const inputContent = props.inputContent || "Drop a File or Click to browse";
  const disabled = props.disabled;

  const [state, setState] = useState({fileCount:0, completed: 0, files:[]});

  const uploadFileToS3 = async (file) => {

    const buffer = new Uint8Array(await file.arrayBuffer());
    const dataArray = [];
    buffer.forEach((x,i)=>{dataArray[i] = x});

    const headers = {...axios.defaults.headers, 'Content-Type': 'application/json'};

    try {
      const urlPrefix = objectType === "FLIGHT" ? `flights/upload/${tripLegUuid}` : `bookings/upload/${awbNumber}`;
      const response = await axios.post(
        `${apiSitePrefix}/${urlPrefix}/${documentUuid}/${file.name}`,
        { document: JSON.stringify(dataArray) },
        { headers }
      );

      //console.error(response);
      if (response && response.data) {
        return response.data;
        if (response.data.status) {
          //setAlert({ severity: "info", open: true, message: "Upload completed successfully", timeOut: 10 });
          //queryClient.invalidateQueries(['DocumentTemplates', ...extraKeys]);
        } else {
          //setAlert({ severity: "error", open: true, message: "The Template file failed to upload with this error: " + response.data.error });
        }
      } else {
        return {
          status: false,
          message: "File could not be uploaded, with unexpected error",
        };

        //setAlert({ severity: "error", open: true, message: "The Template file failed to upload due to an unknown error " });
      }
    } catch (err) {
      console.error(err);
      return {
        status: false,
        message: `File could not be uploaded due to: ${err}`,
      };
      //setAlert({ severity: "error", open: true, message: "The Template file failed to upload with this error: " + err.message });
    }
  }


  const getUploadParams = async ({file, meta}) => {
    const headers = {...axios.defaults.headers, 'Content-Type': 'application/pdf'};
    const urlPrefix = objectType === "FLIGHT" ? `flights/upload` : `bookings/upload`;
    const url = `${apiSitePrefix}/${urlPrefix}/${file.name}`;

    const body = new Uint8Array(await file.arrayBuffer());
    return { url, meta: { fileUrl: `${url}` }, headers, body }
  }

  const removeFileFromArray = (fileName) => {
    const files = [...state.files];
    __.remove(files, {name: fileName});
    return files;
  }

  const handleChangeStatus = async ({ meta, remove, file }, status) => {
    if (status === 'done') {
      const result = await uploadFileToS3(file);
      if (props.onChange) {
        result["fileName"] = file.name;
        result["id"] = documentUuid;
        result["fileSize"] = file.size;
        props.onChange(result);
        const files = removeFileFromArray(file.name);
        if ((state.completed+1) >= state.fileCount && files.length > 0) {
          SystemData.openAlert('Error uploading file', `${files.map(file=>file.name).join(', ')} failed to upload as the filetype is not supported`);
        }
        setState({...state, completed: state.completed + 1, files});
      }
      remove();
    }
    if (status === 'rejected_file_type') {
      if ((state.completed+1) >= state.fileCount) {
        SystemData.openAlert('Error uploading file', `${state.files.map(file=>file.name).join(', ')} failed to upload as the filetype is not supported`);
      }
      setState({...state, completed: state.completed + 1});
  }
    if (status === 'headers_received') {
      //toast(`${meta.name} uploaded!`)
      remove()
    } else if (status === 'aborted') {
      //toast(`${meta.name}, upload failed...`)
    }
  }

  const overrideGetFilesFromEvent = (event) => {
    let newState = {fileCount:0, completed: 0, files:[]};
    const files = [];
    if (event?.dataTransfer?.files && event?.dataTransfer?.files.length > 0) {
      for (let i = 0; i < event.dataTransfer.files.length; i++) {
        files.push({name: event.dataTransfer.files[i].name});
      }
      newState = {fileCount: files.length, completed: 0, files}
    }
    setState(newState);
    return getFilesFromEvent(event);
  }

  return (
    <Dropzone
      accept={accept}
      //getUploadParams={getUploadParams}
      onChangeStatus={handleChangeStatus}
      maxFiles={20}
      multiple={true}
      canCancel={true}
      disabled={disabled}
      inputContent={inputContent}
      styles={{
        dropzone: dropzoneStyle,
        dropzoneActive: { borderColor: 'green' },
        inputLabel: inputLabel
      }}
      getFilesFromEvent={overrideGetFilesFromEvent}
    />
  );
}

export default DropzoneMultiFileUpload;
